import { Form, Button, Alert, InputGroup, Collapse } from 'react-bootstrap';
import { connect } from 'react-redux';
import axiosInstance from '../general/axiosInstance';
import React, { useEffect, useState, useMemo } from 'react';
import { setIsLoading } from '../general/actions';
import { currencyFormater, HOST, DEFAULT_IMG } from '../general/utils';
import ProductImage from '../general/productImage';
import AlertModal from '../general/alertModal';
import { C } from '../general/colors';
import SelectAgreement from '../general/selectAgreement';


function Products(props) {
    const { setIsLoading } = props;

    const [productTypes, setProductTypes] = useState([]);
    const [products, setProducts] = useState([]);
    const [isCreation, setIsCreation] = useState(false);
    const [searchText, setSearchText] = useState('');
    const [agreementFilter, setAgreementFilter] = useState(0);
    const [openBulkUpload, setOpenBulkUpload] = useState(false);

    const [alertModalShow, setAlertModalShow] = useState(false);
    const [alertModalMsg, setAlertModalMsg] = useState('');
    const [alertImgSrc, setAlertImgSrc] = useState('');
    const [alertModalType, setAlertModalType] = useState('');
    const [alertModalOnConfirm, setAlertModalOnConfirm] = useState(null);
    const [alertModalOnClose, setAlertModalOnClose] = useState(null);

    const openImg = (e) => { setAlertModalShow(true); setAlertImgSrc(e.target.src); setAlertModalMsg(''); setAlertModalType(''); };
    useEffect(() => { if (alertModalMsg) setAlertImgSrc(''); }, [alertModalMsg]);

    const getProductTypes = () => {
        setIsLoading(true);
        axiosInstance.get('/product-types')
            .then(res => { setProductTypes(res.data); setIsLoading(false); })
            .catch(err => { setIsLoading(false); setAlertModalType('danger'); setAlertModalMsg(err.response.data.message); });
    };

    const [idEdit, setIdEdit]     = useState('');
    const [agreement, setAgreement] = useState('');
    const [extId, setExtId]       = useState('');
    const [product, setProduct]   = useState('');
    const [isVisible, setIsVisible] = useState(true);
    const [description, setDescription] = useState('');
    const [imgUrl, setImgUrl]     = useState('');
    const [price, setPrice]       = useState(0);
    const [taxes, setTaxes]       = useState(0);
    const [productType, setProductType] = useState('');
    const [selectedImage, setSelectedImage] = useState(null);
    const [message, setMessage]   = useState('');
    const [messageType, setMessageType] = useState('warning');

    const pricePlus = useMemo(() => {
        if (!taxes || !price) return parseFloat(price) || 0;
        return parseFloat(price) * ((parseFloat(taxes) / 100) + 1);
    }, [price, taxes]);

    useEffect(() => {
        setMessageType('warning');
        if (!product) return setMessage('Producto es obligatorio');
        if (!agreement) return setMessage('Contrato es obligatorio');
        if (isNaN(price) || price <= 0) return setMessage('Precio inválido');
        if (isNaN(taxes) || taxes < 0) return setMessage('IVA inválido');
        setMessage('');
    }, [product, agreement, price, taxes]);

    const setEditData = (row) => {
        setIdEdit(row.id); setProduct(row.name); setAgreement(row.agreement_id);
        setDescription(row.description); setExtId(row.ext_id); setIsVisible(row.is_visible);
        setImgUrl(row.img_url); setPrice(parseFloat(row.price)); setTaxes(row.taxes);
        setProductType(row.product_type_id); setSelectedImage(null);
    };

    useEffect(() => {
        if (isCreation) {
            setProduct(''); setAgreement(0); setDescription(''); setIsVisible(true);
            setExtId(''); setIdEdit(false); setImgUrl(''); setPrice(0); setTaxes(0);
            setProductType(''); setSelectedImage(null);
        }
    }, [isCreation]);

    const getProducts = async () => {
        setIsLoading(true);
        try {
            const response = await axiosInstance.get(`/products/agreements/${agreementFilter}`);
            setProducts(response.data);
            if (!response.data.length) { setMessageType('warning'); setMessage('Sin productos en este contrato'); }
            else setMessage('');
            if (!productTypes.length) getProductTypes();
            setIdEdit(0);
        } catch (error) { setAlertModalType('danger'); setAlertModalMsg(error.response.data.message); }
        finally { setIsLoading(false); }
    };

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;
        setSelectedImage(file);
        setImgUrl(URL.createObjectURL(file));
    };

    const uploadImage = () => {
        const fd = new FormData();
        fd.append('image', selectedImage);
        return axiosInstance.post('/upload-image', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
    };

    const getProductData = (imageUrl) => ({
        ext_id: extId, name: product, agreement_id: agreement, description,
        price, taxes, img_url: imageUrl, is_visible: isVisible, product_type_id: productType,
    });

    const submitProduct = () => {
        setIsLoading(true);
        if (selectedImage) {
            uploadImage()
                .then(res => saveProduct(res.data.image_url))
                .catch(err => { setAlertModalType('danger'); setAlertModalMsg(err.response.data.message); });
        } else {
            saveProduct(imgUrl);
        }
    };

    const saveProduct = (imageUrl) => {
        if (isCreation) createProduct(imageUrl); else updateProduct(imageUrl);
    };

    const createProduct = async (imageUrl) => {
        try {
            await axiosInstance.post('/products', getProductData(imageUrl));
            setIsCreation(false); getProducts();
        } catch (error) {
            setMessageType('danger');
            setMessage(error.response.data.message.indexOf('Duplicate') > 0 ? 'Producto ya existe' : error.message);
        } finally { setIsLoading(false); }
    };

    const updateProduct = async (imageUrl) => {
        try {
            await axiosInstance.put(`/products/${idEdit}`, getProductData(imageUrl));
            setIdEdit(0); getProducts();
        } catch (error) {
            setMessageType('danger');
            setMessage(error.response.data.message.indexOf('Duplicate') > 0 ? 'Producto ya existe' : error.message);
        } finally { setIsLoading(false); }
    };

    const deleteProduct = async (id, confirmed) => {
        if (!confirmed) {
            setAlertModalShow(true); setAlertModalType('');
            setAlertModalMsg('¿Está seguro de eliminar el producto ' + id + '?');
            setAlertModalOnConfirm(() => () => { deleteProduct(id, true); });
            return;
        }
        setIsLoading(true);
        try {
            await axiosInstance.delete(`/products/${id}`);
            setAlertModalShow(true); setAlertModalMsg('Producto eliminado correctamente');
            setAlertModalOnClose(() => () => { setIdEdit(null); setIsCreation(false); });
            getProducts();
        } catch (error) {
            setAlertModalShow(true); setAlertModalType('danger');
            setAlertModalMsg(
                error.response.data.message.includes('order_details')
                    ? 'No se puede eliminar: tiene pedidos asociados'
                    : error.response.data.message
            );
        } finally { setIsLoading(false); }
    };

    const bulkUpload = async (e) => {
        setIsLoading(true);
        const formData = new FormData();
        formData.append('file', e.target.files[0]);
        e.target.value = null;
        try {
            await axiosInstance.post('/products/import-csv', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
            getProducts();
        } catch (error) {
            setAlertModalShow(true); setAlertModalType('danger');
            const msg = 'No se creó ningún producto: ';
            if (error.response.data.message.includes('Duplicate')) setAlertModalMsg(msg + 'Hay un producto que ya existe.');
            else if (error.response.data.message.includes('Unexpected')) setAlertModalMsg(msg + 'Formato de archivo inválido.');
            else if (error.response.data.message.includes('agreement')) setAlertModalMsg(msg + 'Contrato inválido en el archivo.');
            else setAlertModalMsg(msg + error.response.data.message);
        } finally { setIsLoading(false); }
    };

    useEffect(() => {
        if (agreementFilter) getProducts();
        else setMessage('Selecciona un contrato para ver los productos');
    }, [agreementFilter]);

    const filtered = products.filter(item =>
        item.name.toLowerCase().includes(searchText.toLowerCase()) ||
        item.description.toLowerCase().includes(searchText.toLowerCase()) ||
        String(item.ext_id).includes(searchText)
    );

    const isFormOpen = idEdit || isCreation;

    return (
        <>
            {!isFormOpen && (
                <div className="order-section">
                    <div className="order-section-header" style={{ justifyContent: 'space-between' }}>
                        <span><i className="fa fa-box" /> Productos</span>
                        <div style={{ display: 'flex', gap: 8 }}>
                            {agreementFilter && (
                                <Button size="sm" variant="primary" onClick={() => setIsCreation(true)}>
                                    <i className="fa fa-plus" /> Crear
                                </Button>
                            )}
                            <Button size="sm" variant="outline-secondary"
                                onClick={() => setOpenBulkUpload(v => !v)}>
                                <i className="fa fa-upload" /> Carga masiva
                            </Button>
                        </div>
                    </div>

                    <Collapse in={openBulkUpload}>
                        <div style={{ background: 'linear-gradient(135deg,#f0f7ff 0%,#f8fafc 100%)', borderBottom: '1px solid var(--abi-border)', padding: '20px 24px' }}>
                            <div style={{ display: 'flex', gap: 32, flexWrap: 'wrap', alignItems: 'flex-start' }}>

                                {/* Pasos */}
                                <div style={{ flex: 1, minWidth: 260 }}>
                                    <div style={{ fontWeight: 700, fontSize: 13, color: 'var(--abi-text)', marginBottom: 14, display: 'flex', alignItems: 'center', gap: 7 }}>
                                        <i className="fa fa-list-ol" style={{ color: C.primary }} /> Cómo hacerlo
                                    </div>
                                    {[
                                        { n: 1, icon: 'fa-download',  color: C.primary,  text: 'Descarga la plantilla CSV con la estructura requerida.' },
                                        { n: 2, icon: 'fa-table',     color: C.accent,   text: 'Completa los campos: ext_id, nombre, precio, IVA, contrato, tipo.' },
                                        { n: 3, icon: 'fa-upload',    color: C.provider, text: 'Sube el archivo CSV y los productos se importarán automáticamente.' },
                                    ].map(s => (
                                        <div key={s.n} style={{ display: 'flex', alignItems: 'flex-start', gap: 12, marginBottom: 10 }}>
                                            <div style={{ width: 28, height: 28, borderRadius: '50%', background: s.color, color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 12, fontWeight: 800, flexShrink: 0 }}>
                                                {s.n}
                                            </div>
                                            <div style={{ fontSize: 13, color: 'var(--abi-text)', paddingTop: 4, lineHeight: 1.5 }}>
                                                <i className={`fa ${s.icon}`} style={{ color: s.color, marginRight: 5 }} />
                                                {s.text}
                                            </div>
                                        </div>
                                    ))}
                                    <a href={HOST + 'storage/files/products.csv'} target="_blank" rel="noreferrer"
                                        style={{ display: 'inline-flex', alignItems: 'center', gap: 7, marginTop: 6, padding: '7px 16px', borderRadius: 8, background: C.primary, color: '#fff', fontSize: 13, fontWeight: 700, textDecoration: 'none' }}>
                                        <i className="fa fa-download" /> Descargar plantilla
                                    </a>
                                </div>

                                {/* Zona de subida */}
                                <div style={{ flex: 1, minWidth: 220 }}>
                                    <div style={{ fontWeight: 700, fontSize: 13, color: 'var(--abi-text)', marginBottom: 14, display: 'flex', alignItems: 'center', gap: 7 }}>
                                        <i className="fa fa-cloud-upload" style={{ color: C.provider }} /> Subir archivo
                                    </div>
                                    <label htmlFor="bulk-upload-input" style={{
                                        display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
                                        gap: 8, padding: '28px 20px', borderRadius: 12, cursor: 'pointer',
                                        border: `2px dashed ${C.primary}55`, background: '#fff',
                                        transition: 'border-color 0.2s, background 0.2s',
                                    }}
                                        onMouseEnter={e => { e.currentTarget.style.borderColor = C.primary; e.currentTarget.style.background = '#eff6ff'; }}
                                        onMouseLeave={e => { e.currentTarget.style.borderColor = `${C.primary}55`; e.currentTarget.style.background = '#fff'; }}
                                    >
                                        <i className="fa fa-file-text-o" style={{ fontSize: 32, color: C.primary, opacity: 0.7 }} />
                                        <div style={{ fontWeight: 600, fontSize: 13, color: 'var(--abi-text)' }}>Haz clic para seleccionar</div>
                                        <div style={{ fontSize: 11, color: 'var(--abi-muted)' }}>Solo archivos <strong>.csv</strong></div>
                                    </label>
                                    <input id="bulk-upload-input" type="file" accept=".csv" style={{ display: 'none' }} onChange={bulkUpload} />
                                </div>

                            </div>
                        </div>
                    </Collapse>

                    <div className="order-section-body" style={{ paddingBottom: 0 }}>
                        <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', marginBottom: 12, alignItems: 'center' }}>
                            <div style={{ minWidth: 240, flex: 2 }}>
                                <SelectAgreement agreement={agreementFilter} setAgreement={setAgreementFilter} disabled={false} />
                            </div>
                            <InputGroup style={{ maxWidth: 260, flex: 1 }}>
                                <InputGroup.Text style={{ background: 'var(--abi-bg)', border: '1px solid var(--abi-border)', borderRight: 'none', fontSize: 12 }}>
                                    <i className="fa fa-search" style={{ color: 'var(--abi-muted)' }} />
                                </InputGroup.Text>
                                <Form.Control placeholder="Buscar producto…" size="sm" value={searchText}
                                    onChange={(e) => setSearchText(e.target.value)} style={{ borderLeft: 'none' }} />
                                {searchText && (
                                    <Button size="sm" variant="outline-secondary" onClick={() => setSearchText('')}>
                                        <i className="fa fa-times" />
                                    </Button>
                                )}
                            </InputGroup>
                            {products.length > 0 && (
                                <span className="report-count"><strong>{filtered.length}</strong> de <strong>{products.length}</strong></span>
                            )}
                        </div>
                    </div>

                    {message && !products.length && (
                        <div className="order-section-body">
                            <Alert variant="info" className="mb-0 py-2" style={{ fontSize: 13 }}>{message}</Alert>
                        </div>
                    )}

                    {filtered.length > 0 && (
                        <table className="report-table mb-0" style={{ width: '100%', borderRadius: 0, border: 'none' }}>
                            <thead>
                                <tr>
                                    <th style={{ width: 48 }}></th>
                                    <th>Producto</th>
                                    <th className="d-none d-md-table-cell">Descripción</th>
                                    <th>Precio + IVA</th>
                                    <th className="d-none d-sm-table-cell">Tipo</th>
                                    <th>Visible</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {filtered.map(item => (
                                    <tr key={item.id}>
                                        <td>
                                            <ProductImage url={item.img_url}
                                                className="pointer order-detail-thumb" alt={item.name}
                                                onClick={openImg}
                                            />
                                        </td>
                                        <td>
                                            <div className="order-detail-name">{item.name}</div>
                                            <div className="order-detail-extid">{item.ext_id}</div>
                                        </td>
                                        <td className="d-none d-md-table-cell order-detail-desc" style={{ maxWidth: 200 }}>
                                            {item.description?.slice(0, 80)}{item.description?.length > 80 ? '…' : ''}
                                        </td>
                                        <td style={{ fontWeight: 600 }}>
                                            {currencyFormater(Math.round(parseFloat(item.price) * ((parseFloat(item.taxes) / 100) + 1)))}
                                            <div style={{ fontSize: 11, color: 'var(--abi-muted)' }}>IVA {item.taxes}%</div>
                                        </td>
                                        <td className="d-none d-sm-table-cell">
                                            <span className="order-detail-type-badge">{item.product_type?.name}</span>
                                        </td>
                                        <td>
                                            <span className="report-status-badge" style={
                                                item.is_visible
                                                    ? { background: '#dcfce7', color: '#166534', border: '1px solid #86efac' }
                                                    : { background: '#f1f5f9', color: '#475569', border: '1px solid #cbd5e1' }
                                            }>
                                                {item.is_visible ? 'Visible' : 'Oculto'}
                                            </span>
                                        </td>
                                        <td style={{ display: 'flex', gap: 4 }}>
                                            <button className="report-icon-btn" title="Editar" onClick={() => setEditData(item)}>
                                                <i className="fa fa-pencil" />
                                            </button>
                                            <button className="report-icon-btn" title="Eliminar" style={{ color: C.danger }}
                                                onClick={() => deleteProduct(item.id)}>
                                                <i className="fa fa-trash" />
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}
                </div>
            )}

            {isFormOpen && (
                <>
                    <div className="order-page-header">
                        <div className="order-page-title">
                            <i className="fa fa-box" style={{ color: 'var(--abi-primary)' }} />
                            {idEdit ? `Modificar Producto #${idEdit}` : 'Crear Producto'}
                        </div>
                        {idEdit && (
                            <Button size="sm" variant="outline-danger" onClick={() => deleteProduct(idEdit)}>
                                <i className="fa fa-trash" /> Eliminar
                            </Button>
                        )}
                    </div>

                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 240px', gap: 16, alignItems: 'start' }}>
                        <div>
                            <div className="order-section">
                                <div className="order-section-header"><i className="fa fa-tag" /> Información del producto</div>
                                <div className="order-section-body">
                                    <div className="mb-3">
                                        <Form.Label className="report-field-label">Contrato</Form.Label>
                                        <SelectAgreement agreement={agreement} setAgreement={setAgreement} disabled={false} />
                                    </div>
                                    <div style={{ display: 'flex', gap: 14, flexWrap: 'wrap' }}>
                                        <div style={{ flex: 1, minWidth: 120 }}>
                                            <Form.Label className="report-field-label">Ext ID / SKU</Form.Label>
                                            <Form.Control type="text" value={extId} placeholder="Código único"
                                                onChange={(e) => setExtId(e.target.value)} />
                                        </div>
                                        <div style={{ flex: 2, minWidth: 180 }}>
                                            <Form.Label className="report-field-label">Nombre del producto</Form.Label>
                                            <Form.Control type="text" value={product}
                                                onChange={(e) => setProduct(e.target.value)} />
                                        </div>
                                        <div style={{ flex: 1, minWidth: 160 }}>
                                            <Form.Label className="report-field-label">Tipo de Producto</Form.Label>
                                            <Form.Select value={productType} onChange={(e) => setProductType(e.target.value)}>
                                                <option value="">— Seleccionar —</option>
                                                {productTypes.map(pt => (
                                                    <option key={pt.id} value={pt.id} disabled={!pt.is_visible}>
                                                        {pt.name}{!pt.is_visible ? ' (inactivo)' : ''}
                                                    </option>
                                                ))}
                                            </Form.Select>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="order-section">
                                <div className="order-section-header"><i className="fa fa-money" /> Precio</div>
                                <div className="order-section-body">
                                    <div style={{ display: 'flex', gap: 14, flexWrap: 'wrap' }}>
                                        <div style={{ flex: 1 }}>
                                            <Form.Label className="report-field-label">Precio antes de IVA</Form.Label>
                                            <Form.Control type="number" value={parseFloat(price)}
                                                onChange={(e) => setPrice(e.target.value)} />
                                            <div style={{ fontSize: 11, color: 'var(--abi-muted)', marginTop: 3 }}>{currencyFormater(price)}</div>
                                        </div>
                                        <div style={{ flex: 1 }}>
                                            <Form.Label className="report-field-label">IVA / Impuesto (%)</Form.Label>
                                            <Form.Control type="number" value={taxes}
                                                onChange={(e) => setTaxes(e.target.value)} />
                                        </div>
                                        <div style={{ flex: 1 }}>
                                            <Form.Label className="report-field-label">Precio + IVA</Form.Label>
                                            <Form.Control disabled type="text" value={currencyFormater(Math.round(pricePlus))}
                                                style={{ fontWeight: 700, color: 'var(--abi-primary)' }} />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="order-section">
                                <div className="order-section-header"><i className="fa fa-align-left" /> Descripción y visibilidad</div>
                                <div className="order-section-body">
                                    <Form.Control as="textarea" rows={4} value={description}
                                        placeholder="Descripción del producto"
                                        onChange={(e) => setDescription(e.target.value)} className="mb-3" />
                                    <Form.Check type="switch" id="product-visible"
                                        label="Visible para pedidos nuevos"
                                        checked={isVisible}
                                        onChange={(e) => setIsVisible(e.target.checked)} />
                                </div>
                            </div>

                            {message && (
                                <Alert variant={messageType} className="py-2" style={{ fontSize: 13 }}>{message}</Alert>
                            )}

                            <div className="order-form-footer">
                                <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
                                    <Button variant="outline-secondary" size="sm"
                                        onClick={() => { setIdEdit(false); setIsCreation(false); }}>
                                        <i className="fa fa-arrow-left" /> Volver
                                    </Button>
                                    <Button variant="primary" size="sm" onClick={submitProduct} disabled={!!message}>
                                        <i className="fa fa-save" /> Guardar
                                    </Button>
                                </div>
                            </div>
                        </div>

                        {/* Image sidebar */}
                        <div className="order-section">
                            <div className="order-section-header"><i className="fa fa-image" /> Imagen</div>
                            <div className="order-section-body" style={{ textAlign: 'center' }}>
                                <ProductImage url={imgUrl}
                                    className="pointer"
                                    alt="Producto"
                                    onClick={openImg}
                                    style={{ width: '100%', maxWidth: 180, aspectRatio: '1 / 1', objectFit: 'cover', borderRadius: 10, border: '1px solid var(--abi-border)', marginBottom: 12 }}
                                />
                                {selectedImage && (
                                    <Alert variant="info" className="py-1 mb-2" style={{ fontSize: 12 }}>
                                        Nueva imagen lista para guardar
                                    </Alert>
                                )}
                                <Form.Control type="file" accept="image/*" size="sm"
                                    onChange={handleImageChange} />
                                {idEdit && (imgUrl || selectedImage) && (
                                    <Button size="sm" variant="outline-danger" className="mt-2 w-100"
                                        onClick={() => { setImgUrl(''); setSelectedImage(null); }}>
                                        <i className="fa fa-trash" /> Eliminar imagen
                                    </Button>
                                )}
                            </div>
                        </div>
                    </div>
                </>
            )}

            <AlertModal
                show={alertModalShow} setShow={setAlertModalShow}
                msg={alertModalMsg} setMsg={setAlertModalMsg}
                onConfirm={alertModalOnConfirm} setOnConfirm={setAlertModalOnConfirm}
                onClose={alertModalOnClose} setOnClose={setAlertModalOnClose}
                imgSrc={alertImgSrc} variant={alertModalType}
            />
        </>
    );
}

function mapStateToProps(state) { return { isLoading: state.isLoading }; }
const mapDispatchToProps = { setIsLoading };
export default connect(mapStateToProps, mapDispatchToProps)(Products);
